export default "__VITE_ASSET__D24UOH3o__"